import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getEmployeesTimes = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEES_TIMES,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
     
    const resp = await client.post(`/api/app/RFC_Tiempos_Empleado/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });

    dispatch({
      type: actions.GET_EMPLOYEES_TIMES,
      payload: resp.data
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_EMPLOYEES_TIMES,
      payload: false
    });
  }
}
